import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Mirrors the backend's @Matches regex on SubmitCryptoHashDto /
 * InitiateCryptoDepositDto. Accepts hex strings 40–128 chars long,
 * optionally prefixed with `0x`. Empty values pass — pair with
 * Validators.required when the field is mandatory.
 */
const TX_HASH_REGEX = /^(0x)?[a-fA-F0-9]{40,128}$/;

export const txHashValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const value: unknown = control.value;
  if (!value || typeof value !== 'string' || value.trim() === '') {
    return null;
  }
  if (!TX_HASH_REGEX.test(value.trim())) {
    return {
      txHash:
        'Transaction hash must be hex characters only (40–128 chars, optionally starting with 0x).',
    };
  }
  return null;
};
